import React from "react";

// Catches anything a route throws while rendering - including a lazy chunk
// that still failed after lazyWithReload's one automatic reload - so the page
// shows a way out instead of React unmounting the whole app to a blank
// screen. `resetKey` (the current path) clears the error on navigation, so
// the header links still work from the error state.
export default class RouteErrorBoundary extends React.Component {
  state = { error: null, resetKey: this.props.resetKey };

  static getDerivedStateFromError(error) {
    return { error };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.resetKey) return { error: null, resetKey: props.resetKey };
    return null;
  }

  componentDidCatch(error, info) {
    console.error("Route render failed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    // Inline styles: a route's own CSS ships in its lazy chunk, which is
    // exactly what may have failed to load.
    return (
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '0 16px',
        textAlign: 'center',
        color: '#ccc',
        background: '#000',
      }}>
        <h2 style={{ margin: 0, color: '#fff' }}>Something went wrong loading this page</h2>
        <p style={{ margin: 0 }}>Check your connection and try again.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #444', background: '#1a1a1a', color: '#fff', cursor: 'pointer' }}
        >
          Reload
        </button>
      </div>
    );
  }
}
